// mutations.js

export default {
    updateConditionsList(state, conditions){
        state.conditionsList = conditions
    }
};
